import { useLocation } from "react-router";
import { cn } from "@/lib/cn";
import { useIsMobile } from "@/lib/use-media-query";
import { usePageHeader } from "@/lib/page-header";
import { ROTAS_COM_VOLTAR_PROPRIO, VoltarAoMenu, useVeioDoMenu } from "../VoltarAoMenu";

/**
 * Nome da página no topo do conteúdo, só no celular. A barra de cima do celular é do seletor de
 * organização (sem título, no desenho do LinkedIn), então o nome vem aqui — em toda página, não
 * só nas abertas pelo Menu. No desktop o nome já está na barra superior: nada aqui.
 */
export function TituloDaPagina({ className }: { className?: string }) {
  const isMobile = useIsMobile();
  const header = usePageHeader();
  if (!isMobile || !header?.title) return null;
  return (
    <h1 className={cn("truncate text-xl font-bold leading-tight text-zinc-900 dark:text-foreground", className)}>
      {header.title}
    </h1>
  );
}

/**
 * O que vai acima do conteúdo de toda página: no celular o nome dela; no desktop o "← Menu" quando
 * ela foi aberta pelo Menu. Páginas de tela cheia (Agenda) desenham isso por conta própria.
 */
export function TopoDoConteudo() {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();
  const header = usePageHeader();
  const veio = useVeioDoMenu();
  if (ROTAS_COM_VOLTAR_PROPRIO.includes(pathname)) return null;
  if (isMobile ? !header?.title : !veio) return null;
  return (
    <div className="mx-auto mb-4 w-full max-w-[1600px]">{isMobile ? <TituloDaPagina /> : <VoltarAoMenu />}</div>
  );
}
